export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    CONFIRM: 'ALERT_CONFIRM',
    DIALOG: 'ALERT_DIALOG',
    WARNING: 'ALERT_WARNING',
    LOADING: 'ALERT_LOADING',
    PRIMARY: 'ALERT_PRIMARY',
    SECONDARY: 'ALERT_SECONDARY',
    INFO: 'ALERT_INFO',
    ERROR: 'ALERT_ERROR',
    LIGHT: "ALERT_LIGHT",
    CLEAR: 'ALERT_CLEAR'
};
